module.exports = __webpack_public_path__ + "static/media/profile_selected.20e941ec.svg";